module.exports = __webpack_public_path__ + "static/media/rotateLeft.1c8d23df.svg";